import { getCoreApiNetworkClient } from "../apiClient/networkClient";
import { useEffect } from "react";
import { useLocalStorage } from "react-storage-complete";
import { IAuth } from "@kunduz/data-access-auth-api";
import { useQuery } from "@tanstack/react-query";

export function useProfiles(token: string): {
  profiles: IAuth.IVerifyOtpResponse["profiles"] | null;
  profilesLoading: boolean;
  profilesError: any;
  refreshProfiles: () => void;
} {
  const [_, setProfiles, _dummy, clearProfiles] =
    useLocalStorage<IAuth.IVerifyOtpResponse["profiles"]>("kunduz_profiles");
  const apiClient = getCoreApiNetworkClient({
    token: token,
  });
  const shouldFetch = !!token;
  const fetcher = (url: string) => apiClient.get(url).then((res) => res.data);

  const { data, error, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ["profiles", token],
    queryFn: () => fetcher(`/auth/profiles/`),
    enabled: shouldFetch,
  });

  useEffect(() => {
    if (!token) {
      //console.log("clearing profiles");
      clearProfiles();
    } else if (data) {
      // console.log("setting proflies", data);
      setProfiles(data);
    }
  }, [data, token]);

  return {
    profiles: shouldFetch ? data : null,
    profilesLoading: isLoading,
    profilesError: error,
    refreshProfiles: refetch,
  };
}
